<template>
  <div v-if="areVariablesMissing" class="w-full py-3 relative">
    <div
      class="h-full w-fit px-5 bg-primary flex items-center justify-center rounded-l-lg z-10 absolute left-0 top-0"
    >
      <Icon
        :size="IconSize.LG"
        :name="IconName.INFO_CIRCLE"
        class="text-on-primary"
      />
    </div>
    <div
      class="relative z-20 pl-20 pr-10 h-full w-full flex gap-4 md:gap-5 items-center flex-wrap"
    >
      <span class="md:text-left">
        {{ $t('variables-banner.description') }}
      </span>
      <Button
        :label="$t('variables-banner.personalize')"
        :size="ButtonSize.SM"
        :variant="ButtonVariant.OUTLINED"
        @click="handleActivateVariablesModal"
      />
    </div>

    <div
      class="bg-primary opacity-10 w-full h-full absolute left-0 top-0 rounded-lg z-10"
    />
    <div class="bg-[white] w-full h-full absolute left-0 top-0 rounded-lg" />
  </div>
</template>

<script setup lang="ts">
import { computed, useCustomDescription } from '#imports';
import { storeToRefs } from 'pinia';
import {
  Button,
  ButtonSize,
  ButtonVariant,
  Icon,
  IconName,
  IconSize,
} from '@exfluential/ui';
import { useAccountStore } from '~/store/account';
const { activateVariablesModal } = useCustomDescription('');

const { accountVariables } = storeToRefs(useAccountStore());

const areVariablesMissing = computed(() =>
  accountVariables
    ? !accountVariables.value.company ||
      !accountVariables.value.website ||
      !accountVariables.value.phoneNumber
    : false,
);

const handleActivateVariablesModal = () => {
  activateVariablesModal({
    website: !accountVariables.value.website,
    phoneNumber: !accountVariables.value.phoneNumber,
    company: !accountVariables.value.company,
  });
};
</script>
